function getDefaultUserAgent() {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent;
  }
}

export default getDefaultUserAgent;
